import { render } from "./CustomDomainStarters.vue?vue&type=template&id=5bee1009"
import script from "./CustomDomainStarters.vue?vue&type=script&lang=js"
export * from "./CustomDomainStarters.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.8.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__